import { useBookEditor } from "./BookEditorProvider";

export default function BookEditorStatusBar() {
  const {
    mode,
    pages,
    chapters,
    activePage,
    preflightIssues,
    saveStatus,
  } = useBookEditor();

  const critical = (preflightIssues || []).filter((i) => i.severity === "critical").length;
  const pageCount = pages?.length || 0;

  return (
    <footer className="book-editor-status" data-testid="book-editor-status">
      <span data-testid="status-mode">Mode · {mode}</span>
      <span data-testid="status-chapters">{chapters?.length || 0} chapters</span>
      <span data-testid="status-pages">
        {pageCount
          ? `${pageCount} persisted page${pageCount === 1 ? "" : "s"}`
          : "No persisted pages yet"}
      </span>
      {activePage && (
        <span data-testid="status-active-page-id">Page · {activePage.id}</span>
      )}
      <div className="book-editor-status__spacer" />
      <span data-testid="status-save">{saveStatus}</span>
      {critical > 0 ? (
        <span className="book-editor-status__critical" data-testid="status-preflight-critical">
          {critical} critical
        </span>
      ) : (
        <span data-testid="status-preflight-ok">
          Preflight idle
        </span>
      )}
    </footer>
  );
}
